import { Flex } from '@chakra-ui/react';
import { NonTimedAuctions } from './components/AuctionLists/NonTimedAuctions.tsx';
import { TimedAuctions } from './components/AuctionLists/TimedAuctions.tsx';
import { UpcomingAuctions } from './components/AuctionLists/UpcomingAuctions.tsx';
import { AdBanner } from '../advertisement/AdBanner.tsx';
import { AuctionBanner } from './components/AuctionBanner.tsx';
import { AdvertisementPosition } from '../advertisement/types.ts';

export const HomePage = () => {
  return (
    <Flex gap={'16px'} direction={'column'}>
      <AuctionBanner />
      <NonTimedAuctions />
      <TimedAuctions />
      <AdBanner numberOfAdsToDisplay={3} position={AdvertisementPosition.General} />
      <UpcomingAuctions />
    </Flex>
  );
};
